import React, { VoidFunctionComponent, useState } from 'react';

export const ToolTip: VoidFunctionComponent<{label: string}> = ({ label }) => {
    const [isTooltipVisible, setTooltipVisible] = useState(false);

    return (
        <div className="tooltip-fp"
            onMouseEnter={() => setTooltipVisible(true)}
            onMouseLeave={() => setTooltipVisible(false)}
        >
            <img src="/assets/images/responsive/icons/info.svg" />
            {isTooltipVisible ? <p className="tooltipLabel">{label}</p> : undefined}
        </div>

    )
}
